import { render, staticRenderFns } from "./ContactEditAwsDocuments.vue?vue&type=template&id=fd5b28ac"
import script from "./ContactEditAwsDocuments.vue?vue&type=script&lang=ts"
export * from "./ContactEditAwsDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports